<template>
  <div class="notifications-panel" v-if="finish">
    <SidebarHeader
      :menuItems="adminOptions"
    >
      <template #title>Notifications</template>

      <div class="notifications-panel__types">
        <div
          v-for="tab in notificationTypes"
          class="notification-tab"
          :class="[{ current: tab.id === currentNotificationType }, tab.id]"
          :key="tab.id"
          :id="tab.id"
          @click="changeNotificationType"
        >
          {{ `${tab.name} (${tab.no})` }}
        </div>
      </div>
    </SidebarHeader>


    <div class="notifications-list" :class="[currentNotificationType]" v-if="filteredNotifications.length > 0">
      <SidebarNotificationContainer
        v-for="(notification, index) in filteredNotifications"
        :key="notification.id"
        :notification="notification"
        :currentNotificationType="currentNotificationType"
        :index="index"
        :class="{ viewed: notification.viewed }"
      />
    </div>
    <div class="no-notifications" v-else>
      You haven't {{ currentNotificationType }} <br />
      any new notifications
    </div>
  </div>

  <div class="notifications-panel" v-else>
    <div class="loading-icon-container">
      <LoadingIcon/>
    </div>
  </div>
</template>

<script>
import SidebarNotificationContainer from './SidebarNotificationContainer.vue';
import BroadcastForm from '@/components/modals/notifications/BroadcastForm.vue'
import LoadingIcon from '@/components/global/loading/LoadingIcon.vue'
import SidebarHeader from '../SidebarHeader.vue';

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NotificationsPanel',
  components: {
    SidebarNotificationContainer,
    LoadingIcon,
    SidebarHeader
  },
  data() {
    return {
      finish: false,
      currentNotificationType: 'received',
      broadcastForRemoval: null,
      showConfirm: false,
      removePopupData: {}
    };
  },
  computed: {
    ...mapGetters({
      notifications: 'getUserNotifications',
      sentNotifications: 'getSentNotifications',
      newNotification: 'getNewNotification',
      currentNotification: 'getCurrentNotification',
      userType: 'current_user/currentAreaPermissionNo'
    }),
    filteredNotifications() {
      //filters (remove display=false,etc) on get + set in state actions
      //set notifications depending on tab type (sent/received)
      let notificationsList = [];

      if (this.currentNotificationType === 'received') {
        notificationsList = this.notifications;
      } else {
        notificationsList = this.sentNotifications;
      }

      return notificationsList;
    },
    notificationTypes() {
      let notificationTypes = [
        {
          name: 'Received',
          id: 'received',
          no: this.notifications.length
        },
        {
          name: 'Sent',
          id: 'sent',
          no: this.sentNotifications.length
        }
      ];
      return notificationTypes;
    },
    adminOptions: vm => [
      {
        icon: 'delete',
        text: 'Clear All Notifications',
        show: vm.filteredNotifications.length,
        click: () => vm.clearAllNotifications(vm.currentNotificationType === 'sent')
      },
      {
        icon: 'broadcast',
        text: `Create Broadcast`,
        show: vm.userType,
        click: () => vm['modal/open']([BroadcastForm])
      }
    ],
  },
  methods: {
    ...mapActions([
      'clearNewNotification',
      'clearAllNotifications',
      'modal/open'
    ]),
    changeNotificationType(event) {
      let type = event.target.id;
      if (type !== this.currentNotificationType) {
        this.currentNotificationType = type;
      }
    },
    checkIfMissedCurrentInvite() {
      if (this.currentNotification && this.currentNotification.response === null) {
        let missedInvite = this.currentNotification.status === 'missed'
        if (missedInvite) {
          this.clearNewNotification()
        }
      }
    },
  },
  mounted() {
    this.clearNewNotification()
    this.checkIfMissedCurrentInvite();
    this.$store.dispatch('fetchNotifications');
    setTimeout(() => {
      this.finish = true;
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/components/sidebar/notifications_panel.scss';
</style>
